// GLOBAL JS - Prestige Wear v5 - Performance Optimisé
// - Délégation d'événements (zéro listener lourd au load)
// - Init lazy via requestIdleCallback
// - Scroll handler en passive + throttling natif (rAF)
(function(){
  'use strict';

  // ===== MOBILE MENU (init léger - seulement les bindings critiques) =====
  function initMobileMenu(){
    var mobileToggle = document.querySelector('.header__mobile-toggle');
    var mobileMenu = document.getElementById('mobileMenu');
    var mobileClose = document.getElementById('mobileClose');
    var mobileOverlay = document.getElementById('mobileOverlay');

    function openMobile(){
      if(mobileMenu){mobileMenu.classList.add('active');mobileMenu.removeAttribute('inert');}
      if(mobileOverlay)mobileOverlay.classList.add('active');
      document.body.style.overflow='hidden';
    }
    function closeMobile(){
      if(mobileMenu){mobileMenu.classList.remove('active');mobileMenu.setAttribute('inert','');}
      if(mobileOverlay)mobileOverlay.classList.remove('active');
      document.body.style.overflow='';
    }

    if(mobileToggle)mobileToggle.addEventListener('click',openMobile);
    if(mobileClose)mobileClose.addEventListener('click',closeMobile);
    if(mobileOverlay)mobileOverlay.addEventListener('click',closeMobile);

    // Délégation : un SEUL listener pour tous les triggers
    if(mobileMenu){
      mobileMenu.addEventListener('click',function(e){
        var trigger=e.target.closest('.mobile-menu__trigger');
        if(!trigger)return;
        e.preventDefault();
        e.stopPropagation();
        var group=trigger.closest('.mobile-menu__group');
        if(!group)return;
        var wasOpen=group.classList.contains('open');
        var openGroups=mobileMenu.querySelectorAll('.mobile-menu__group.open');
        for(var i=0;i<openGroups.length;i++){openGroups[i].classList.remove('open');}
        if(!wasOpen)group.classList.add('open');
      });
    }
  }

  // ===== CART QUANTITY (délégation - zéro listener inline) =====
  function initCart(){
    document.addEventListener('change',function(e){
      var input=e.target;
      if(!input.matches('.cart-item__quantity input'))return;
      var line=input.dataset.index;
      var qty=parseInt(input.value);
      if(isNaN(qty)||qty<0)qty=0;
      fetch('/cart/change.js',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({line:parseInt(line),quantity:qty})
      }).then(function(r){return r.json();})
        .then(function(){window.location.reload();})
        .catch(function(err){console.error(err);});
    });

    document.addEventListener('click',function(e){
      var btn=e.target.closest('.cart-qty-minus,.cart-qty-plus');
      if(!btn)return;
      var input=btn.parentElement.querySelector('input');
      if(!input)return;
      var val=parseInt(input.value)+(btn.classList.contains('cart-qty-minus')?-1:1);
      if(val<0)val=0;
      input.value=val;
      input.dispatchEvent(new Event('change'));
    });
  }

  // ===== SCROLL EFFECTS (passive + rAF) =====
  function initScroll(){
    var header=document.querySelector('.header');
    if(!header||!header.classList.contains('sticky'))return;
    var ticking=false;
    window.addEventListener('scroll',function(){
      if(!ticking){
        window.requestAnimationFrame(function(){
          if(window.pageYOffset>100){header.classList.add('scrolled');}
          else{header.classList.remove('scrolled');}
          ticking=false;
        });
        ticking=true;
      }
    },{passive:true});
  }

  // ===== INIT =====
  function init(){
    initMobileMenu();
    initCart();
    initScroll();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  } else {
    init();
  }
})();
